export class RobotPartHealthCounter {
  public part_id: string;
  public part_name: string;
  public counter: number;
  public counter_category: string;
  public minutes_remaining: number;
  public minutes_used: number;
  public reset_usage: string;
  public reset_by: string;
  public count_type: string;
  public count_remaining: number;
  public count_used: number;
  /** Total (used + remaining) used only for UI */
  public count_total?: number;
}

export class RobotPartHealth {
  public robot_id: string;
  public robot_name: string;
  public robot_sku: string;
  public robot_series: string;
  public robot_timezone: string;
  public robot_regdate: string;
  public robot_serial_number?: string;
  public expiry_dttm: number;
  public part_counters: RobotPartHealthCounter[];
  public database?: string;
  public table_name?: string;
  public version?: string;
  public updated_time?: string;
  public partition_key?: string;
  public sort_key?: string;
}
